import moment from "moment";
import { getExerciseName } from "../parts/modals/learn-more/blockHelpers";

/**
 * Returns an array of exercise names for a period (week or session) to use as custom filters
 *
 * @param exercises {Array} Array of exercises to filter from
 * @param query {Object} query object
 * @returns {String[]} array with exercise names
 */
export const getExerciseNamesList = (exercises = [], query = {}) => {
  const filters = {};
  const { day, session, type, week } = query;

  if (week) filters.programWeek = week;
  if (session) filters.programSession = session;

  const filteredExercises = exercises.filter(({ cycle, utcDate }) => {
    if (query.cycle && !cycle) return false;
    if (type === "calendar-week" && !day) return false;

    if (type === "calendar-week") {
      // in calendar, filter by date
      const start = Number(moment.utc(day, "YYYY-MM-DD").format("YYYYMMDD"));
      const end = Number(
        moment.utc(day, "YYYY-MM-DD").add(7, "days").format("YYYYMMDD")
      );
      if (utcDate < start || utcDate > end) return false;
    } else {
      // in program editor, filter by program week, program session or both
      for (const key in filters) {
        if (cycle[key] === undefined || cycle[key] != filters[key])
          return false;
      }
    }

    return true;
  });

  const exercisesNames = filteredExercises.map((exercise) =>
    getExerciseName(exercise).trim()
  );
  // use Set to remove duplicates
  return [...new Set(exercisesNames)];
};
